import { Layer } from 'interfaces/maps.interface';
import { PLACE_SOURCE_TYPES } from 'utils/constants';

export const TOTAL_SUGGESTIONS_ALLOWED = 1;
export const SUGARCANE_SUPPORTED_SEASON_IDS = ['323'];

export const ALL_LAYERS: Record<string, Layer> = {
	'FARMS-USER_FARM-SUGARCANE_24_PROGRAM_TYPE': {
		PlaceNamespace: 'FARMS',
		PlaceGeometryType: 'INVALID_GEOMETRY_TYPE',
		MinZoomLevel: 16,
		MaxZoomLevel: 19,
		PlaceSourceType: PLACE_SOURCE_TYPES.USER_FARM,
		PlaceVisibleType: 'SUGARCANE_24_PROGRAM_TYPE',
	},
};
